import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useForm } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import CardPicker from '../../../../../../packages/kiti/components/form/CardPicker'
import ColorPicker from '../../../../../../packages/kiti/components/form/ColorPicker'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Select from '../../../../../../packages/kiti/components/form/Select'

const EditWidgetForm = () => {
  const { t } = useTranslation('common')
  const form = useForm()
  return (
    <>
      <Col width="100%">
        <FormItem
          label={t('widgets.period')}
          path={['data', 'periodType']}
          Input={Select}
          options={[
            { id: 'time_of_day', name: t('widgets.timeOfDay') },
            { id: 'day_of_week', name: t('widgets.dayOfWeek') }
          ]}
          selectOnlyId
          disableEmptyOption
        />
      </Col>

      {form.data.presentation === 'bars' && (
        <Col width="100%">
          <FormItem label={t('widgets.barColor')} path={['data', 'color']} Input={ColorPicker} />
        </Col>
      )}
    </>
  )
}

export default EditWidgetForm
